import fetch from 'cross-fetch'

const SUCCESSFUL_RESPONSE = 1;
const REGISTER_NEWSLETTER_ENDPOINT = '/v3/newsletter/subscription';
const STATUS_SUBSCRIBED = 'subscribed';
const getUnsubscribeEndpoint = uuid => `/v3/newsletter/subscription/${uuid}/unsubscribe`;
const getUpdatePreferencesEndpoint = uuid => `/v3/newsletter/subscription/${uuid}/update`;

const post = (path, data) => {
  let fetchSettings = {
    method: 'POST',
    body: data
  }

  return fetch(path, fetchSettings)
  .then(handleErrors)
  .then(response => response.json())
  .catch(console.error)
}

const get = (path) => {
  let fetchSettings = {
    method: 'GET',
    headers: {
      'X-Accept': 'application/json',
      'Content-Type': 'application/json; charset=UTF8 ',
    },
  }

  return fetch(path, fetchSettings)
  .then(handleErrors)
  .then(response => response.json())
  .catch(console.error)
}

const handleErrors = (response) => {
  if (!response.ok) throw Error(response.statusText)
  return response
}

const registerEmail = (data = {}, onSuccess, onError, onFinished) => {
  let formData = new FormData();
  formData.append('frequency', 'daily');

  for (const key in data) {
    formData.append(key, data[key]);
  }

  post(REGISTER_NEWSLETTER_ENDPOINT, formData)
  .then(response => {
    if (response && response.status === SUCCESSFUL_RESPONSE) {
      onSuccess({
        success: true,
        message: 'Frequency successfully updated!',
      }, response.signedParams);
    } else {
      onError({
        success: false,
        message: "An error occurred. Please try again later.",
      });
    }
    onFinished();
  })
}

const unsubscribe = (uuid, onSuccess, onError, onFinished) => {
  get(getUnsubscribeEndpoint(uuid), onSuccess, onError)
  .then(response => {
    if (response.status === SUCCESSFUL_RESPONSE) {
      onSuccess({
        success: true,
        message: 'You are now unsubscribed.',
      });
    } else {
      onError({
        success: false,
        message: "An error occurred. Please try again later.",
      });
    }
    onFinished();
  })
  .catch(error => console.error('Error:', error));
}

const updatePreferences = (uuid, data = {}, onSuccess, onError, onFinished) => {
  let formData = new FormData();
  formData.append('status', STATUS_SUBSCRIBED);

  for (const key in data) {
    formData.append(key, data[key]);
  }

  post(getUpdatePreferencesEndpoint(uuid), formData)
  .then(response => {
    if (response.status === SUCCESSFUL_RESPONSE) {
      onSuccess({
        success: true,
        message: 'Done! We hope you like this better.',
      }, response.signedParams);
    } else {
      onError({
        success: false,
        message: "An error occurred. Please try again later.",
      });
    }
    onFinished();
  })
}

export {registerEmail, unsubscribe, updatePreferences}
